import { AppConfig } from '../../../app-config'
import { triggerSimpleAjax } from '../../../utils/http-helper'
import sort from '../../../utils/sort'

/**
 * This function used to generate the indian cities in GCM and send response through callback action
 * @param {*} callbackAction
 */
export default function getIndianCities(callbackAction = () => {}) {
	let url = `${AppConfig.api_url}location/indianCities`
	triggerSimpleAjax({
		url,
		method: 'GET',
		body: {},
		onSuccess: response => {
			const allCities = response.data
			const popularCities = []
			const otherCities = []
			allCities.map(city => {
				;(city.popular ? popularCities : otherCities).push({
					label: city.cityName,
					value: city.airportCode,
				})
			})
			callbackAction(
				popularCities.concat(sort(otherCities, ['cityName'], false)),
			)
		},
	})
}
